import { useAppDispatch, useAppSelector } from "app.hook";
import * as React from "react";
import { ModalComponent } from "shared/components/modal/modal";
import { closeOrderGuestModal, selectVisibleOrderGuestModal } from "states/global-value/global-value.slice";
import { shallowEqual } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { ACCOUNT_LOGIN_ROUTE, CHECKOUT_ROUTE } from "shared/constants/routes";
import "./select-order-method-modal.less";
export function SelectOrderMethodModal() {
  const visibleOrderGuestModal = useAppSelector(selectVisibleOrderGuestModal, shallowEqual);
  const dispatch = useAppDispatch();
  const history = useHistory();
  return (
    <>
      <ModalComponent
        portalClassName={`ReactModalPortalSelectOrderMethod`}
        isModal={true}
        className="w-full bg-white rounded-2xl"
        onOk={() => {
          dispatch(closeOrderGuestModal());
        }}
        isCustomizeFooter={true}
        onCancel={() => {
          dispatch(closeOrderGuestModal());
        }}
        title={"SELECT ORDER METHOD"}
        isOpenModal={visibleOrderGuestModal}
        onCloseModal={() => {
          dispatch(closeOrderGuestModal());
        }}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4  px-4 py-4  content-center items-center">
          <button className="button-container font-bold uppercase btn--default px-6 py-8 rounded-none btn--primary inline" onClick={() => {
            dispatch(closeOrderGuestModal());
            history.push(CHECKOUT_ROUTE);
          }}>
            Ordering as Guest
          </button>
          <button className="button-container font-bold uppercase btn--default px-6 py-8 rounded-none btn--primary inline" onClick={() => {
            window.location.href =
              ACCOUNT_LOGIN_ROUTE + "?callback=/order-website/checkout";
          }}>
            Ordering with an account
          </button>
        </div>
      </ModalComponent>
    </>
  );
}
